import React from 'react';
import styled from 'libs/styled';
import { type HighlightedTextComponentProps } from 'content/HighlightedText';
import HighlightedTextBlock from 'libs/sanity/content/Blocks/HighlightedTextBlock';

interface HighlightedTextModuleProps {
    data: {
        block: HighlightedTextComponentProps;
    };
}

const ModuleWrapper = styled('div')`
    margin: var(--module-margin-y) 10px;
`;

const HighlightedTextModule: React.FC<HighlightedTextModuleProps> = (data) => {
    const { data: moduleData } = data;
    const blockData = moduleData?.block || moduleData;
    return (
        <ModuleWrapper>
            <HighlightedTextBlock data={blockData} />
        </ModuleWrapper>
    );
};
export default HighlightedTextModule;
